import React from 'react';
import { cn } from '@/lib/utils';

export const NumberBall = ({ number, variant = 'main', type, size = 'md', showIndex = false, indexValue = null }) => {
  // Support both 'variant' and 'type' props for backwards compatibility
  const ballType = type || variant || 'main';
  
  const sizeClasses = {
    xs: 'w-[18px] h-[18px] text-[10px]',
    sm: 'w-8 h-8 text-sm',
    md: 'w-[36px] h-[36px] text-base',
    lg: 'w-12 h-12 text-lg font-bold'
  };

  const typeClasses = {
    main: 'bg-gradient-to-br from-amber-500 via-yellow-500 to-amber-600 text-gray-900 shadow-lg shadow-amber-500/30 border-2 border-amber-300',
    bonus: 'bg-gradient-to-br from-blue-500 via-blue-600 to-indigo-600 shadow-lg shadow-blue-500/30 border-2 border-blue-400 !text-white',
    // German Lotto Superzahl (0-9) - distinct purple/violet style
    superzahl: 'bg-gradient-to-br from-purple-500 via-violet-500 to-purple-600 shadow-lg shadow-purple-500/30 border-2 border-purple-400 !text-white',
    // La Primitiva Reintegro (0-9) - teal style
    reintegro: 'bg-gradient-to-br from-teal-500 via-teal-600 to-emerald-600 shadow-lg shadow-teal-500/30 border-2 border-teal-400 !text-white',
    // La Primitiva Complementario - orange style
    complementario: 'bg-gradient-to-br from-orange-500 via-orange-600 to-red-500 shadow-lg shadow-orange-500/30 border-2 border-orange-400 !text-white',
    hot: 'bg-gradient-to-br from-red-500 via-orange-500 to-red-600 shadow-lg shadow-red-500/20 !text-white',
    cold: 'bg-gradient-to-br from-cyan-400 via-blue-400 to-cyan-500 shadow-lg shadow-cyan-500/20 !text-white'
  };

  return (
    <div className="flex flex-col items-center gap-1">
      <div
        className={cn(
          'rounded-full flex items-center justify-center font-semibold',
          sizeClasses[size],
          typeClasses[ballType] || typeClasses.main
        )}
        style={['bonus', 'superzahl', 'reintegro', 'complementario'].includes(ballType) ? { color: '#ffffff', fontWeight: 700 } : {}}
        data-testid={`number-ball-${number}`}
      >
        {number}
      </div>
      {showIndex && indexValue !== null && (
        <span className="text-xs text-gray-400">{(indexValue * 100).toFixed(0)}%</span>
      )}
    </div>
  );
};

export default NumberBall;
